var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.42,
    height: 15.229,
    viewBox: "0 0 17.42 15.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company_selected",
    "data-name": "Company selected",
    transform: "translate(-499.999 -373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "store_24dp_FILL1_wght300_GRAD0_opsz24_1_",
    "data-name": "store_24dp_FILL1_wght300_GRAD0_opsz24 (1)",
    d: "M126.448-788.526V-790h15.3v1.474Zm.038,13.755v-5.895h-1.1v-1.474l1.058-4.912h15.3l1.058,4.912v1.474h-1.1v5.895h-1.474v-5.895h-4.421v5.895Zm1.474-1.474h6.386v-4.421h-6.386Z",
    transform: "translate(374.609 1163)",
    fill: "#66939f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySelected);
export default __webpack_public_path__ + "static/media/company-selected.91db4a385cd60d7fc7c4db9607aa4260.svg";
export { ForwardRef as ReactComponent };